<template>
  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <!--Placeholder for centering the input STARTS-->
      <v-col cols="0" sm="1">
          <v-sheet>
          </v-sheet>
      </v-col>
      <!--Placeholder for centering the input ENDS-->
      <v-col cols="10">
        <v-text-field class="elevation-20"
            label="Link to the Reddit Post"
            prepend-inner-icon="link"
            solo
            flat
            rounded
            clearable
            hide-details
            height="56px"

            v-model="link"
            v-on:keyup.enter="download"
          ></v-text-field>
      </v-col>
      <v-col cols="2" sm="1">
          <v-btn
          color="#f78d00"
          elevation=20
          dark
          fab
          depressed

          v-on:click="download"
          >
             <v-icon>save_alt</v-icon>
          </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center" no-gutters>
      <v-col cols=12 sm="9">
        <ProTip/>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <TopVideos/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TopVideos from './TopVideos.vue'
import ProTip from './ProTip.vue'
export default {
  methods: {
   download: function() {
      var url = new URL(this.link)
      this.$router.push(url.pathname)
      //TODO: validate url
    }
  },
  data: () => ({
    link: ""
  }),
  components: {
    TopVideos,
    ProTip
  }
};
</script>